import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";

export interface LegalSection {
  heading: string;
  paragraphs: string[];
}

interface LegalBodyProps {
  breadcrumb: string;
  title: string;
  description: string;
  updated: string;
  sections: LegalSection[];
}

export default function LegalBody({
  breadcrumb,
  title,
  description,
  updated,
  sections,
}: LegalBodyProps) {
  return (
    <>
      <PageHero eyebrow="Legal" breadcrumb={breadcrumb} title={title} description={description} />

      <section className="w-full bg-background-50 py-16 md:py-24">
        <div className="mx-auto w-full max-w-container px-4 md:px-6">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
            <Reveal className="lg:col-span-3">
              <nav aria-label="On this page" className="lg:sticky lg:top-28">
                <p className="font-label text-xs font-semibold uppercase tracking-[0.16em] text-foreground-500">
                  On this page
                </p>
                <ul className="mt-4 space-y-2.5">
                  {sections.map((section) => (
                    <li key={section.heading}>
                      <span className="text-sm text-foreground-700">{section.heading}</span>
                    </li>
                  ))}
                </ul>
                <p className="mt-6 rounded-md border border-background-200 bg-background-100 px-4 py-3 text-xs text-foreground-500">
                  Last updated: {updated}
                </p>
              </nav>
            </Reveal>

            <div className="lg:col-span-9">
              <div className="space-y-10">
                {sections.map((section, index) => (
                  <Reveal key={section.heading} delay={index * 0.04}>
                    <article>
                      <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">
                        {section.heading}
                      </h2>
                      <div className="mt-4 space-y-3">
                        {section.paragraphs.map((paragraph) => (
                          <p key={paragraph} className="text-sm leading-relaxed text-foreground-600">
                            {paragraph}
                          </p>
                        ))}
                      </div>
                    </article>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}